import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const URLIcon: React.FC<AddIconProps> = ({ size = 17, color = '#1E1E1E', className, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.50081 15.5841C12.4128 15.5841 15.5841 12.4128 15.5841 8.50081C15.5841 4.5888 12.4128 1.41748 8.50081 1.41748C4.5888 1.41748 1.41748 4.5888 1.41748 8.50081C1.41748 12.4128 4.5888 15.5841 8.50081 15.5841Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.66696 2.125H6.37529C4.99404 6.26167 4.99404 10.7383 6.37529 14.875H5.66696" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.625 2.125C12.0062 6.26167 12.0062 10.7383 10.625 14.875" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.125 11.3333V10.625C6.26167 12.0062 10.7383 12.0062 14.875 10.625V11.3333" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.125 6.37529C6.26167 4.99404 10.7383 4.99404 14.875 6.37529" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default URLIcon;
